import React, { useEffect, useRef, useState } from "react"
import './Header.scss'
import { Navbar, NavDropdown, Container, Nav } from "react-bootstrap"
import 'bootstrap/dist/css/bootstrap.min.css';
import enFlag from './en.png'
import nlFlag from './nl.png'
import banner from './banner.png'

interface HeaderProps {
	lang: String,
	setLang: React.Dispatch<React.SetStateAction<string>>
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
	const lang = props.lang

	const [isSticky, setIsSticky] = useState(false);
	const [headerHeight, setHeaderHeight] = useState(0)
	const bannerRef = useRef<HTMLImageElement>(null);
	const headerRef = useRef<HTMLImageElement>(null);
	
	const measureBanner = () => {if (bannerRef.current) {const height = bannerRef.current.offsetHeight; setHeaderHeight(height)}}

	useEffect(() => {
		const handleScroll = () => {
			if (bannerRef.current) {
				if ((window.scrollY || window.pageYOffset) > bannerRef.current.offsetHeight) {
					setIsSticky(true)
				} else {
					setIsSticky(false)
				}
			}
		}
		window.addEventListener('resize', measureBanner)
		window.addEventListener('scroll', handleScroll)
		return () => {window.removeEventListener('scroll', handleScroll);window.removeEventListener('resize', measureBanner)}
	}, [])

	return (<div className="header" style={{position:'sticky', top: -headerHeight + 'px'}}>
		<img src={banner} alt="Banner" className="banner" ref={bannerRef} onLoad={measureBanner}></img>
		<Navbar variant="dark" expand="lg" className={isSticky ? "roze sticky-top" : 'roze'} ref={headerRef}>
			<Container>
				<Navbar.Brand href="/">Women at the Top</Navbar.Brand>
				<Navbar.Toggle aria-controls="nav"></Navbar.Toggle>
				<Navbar.Collapse id="nav">
					<Nav className="me-auto">
						<Nav.Link href="/information">{lang === 'nl' ? "Informatie" : "Information"}</Nav.Link>
						<Nav.Link href="/register">{lang === 'nl' ? "Inschrijven" : "Register"}</Nav.Link>
						<Nav.Link href="/nomination">{lang === 'nl' ? "Nominatie" : "Nomination"}</Nav.Link>
						<Nav.Link href="/partners">Partners</Nav.Link>
						<NavDropdown title={lang === 'nl' ? "Edities" : "Editions"}>
							<NavDropdown.Item className="d-flex justify-content-center" href="/editions/2025">2025</NavDropdown.Item>
							<NavDropdown.Item className="d-flex justify-content-center" href="/editions/2024">2024</NavDropdown.Item>
							<NavDropdown.Item className="d-flex justify-content-center" href="/editions/2023">2023</NavDropdown.Item>
						</NavDropdown>
						<NavDropdown title={lang === 'nl' ? "Rolmodellen" : "Rolemodels"}>
							<NavDropdown.Item className="d-flex justify-content-center" href="/rolemodels/2026">2026</NavDropdown.Item>
							<NavDropdown.Item className="d-flex justify-content-center" href="/rolemodels/2025">2025</NavDropdown.Item>
							<NavDropdown.Item className="d-flex justify-content-center" href="/rolemodels/2024">2024</NavDropdown.Item>
						</NavDropdown>
					</Nav>
					<Container className="d-flex justify-content-center">
						<Nav.Link onClick={() => {props.setLang('en');setLangCookie('en')}}><img className="flag" src={enFlag} alt="To English site" /></Nav.Link>
						<Nav.Link onClick={() =>{ props.setLang('nl');setLangCookie('nl')}}><img className="flag" src={nlFlag} alt="Naar Nederlandse site"></img></Nav.Link>
					</Container>
				</Navbar.Collapse>
			</Container>
		</Navbar>
		{/* {isSticky && (<div style={{height: headerHeight}}></div>)} */}
	</div>)
}

function setLangCookie(lan:String) {
	const date = new Date()
	date.setTime(date.getTime() + 365*24*60*60*1000)
 	document.cookie = "language=" + lan + ";path=/;expires="+date.toUTCString()+';'
}
function getLangCookie() {
	const cookies = document.cookie.split(';')
	for (var i in cookies) {
		const c = cookies[i].split("=")
		if (c[0].trim()==="language") {
			return c[1].trim()
		}
	}
	return 'en'
}
export {Header, getLangCookie}